import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "side-nav-bar"
}
const _hoisted_2 = ["src"]
const _hoisted_3 = {
  key: 1,
  class: "nav-button"
}

import { ref, computed } from 'vue';
import { useRoute, useRouter } from 'vue-router';

import logo from '@/assets/duelly_top_nav_log.svg';
import ProfilePhoto from '@/components/ProfilePhoto.vue';
import { useAuthStore } from '@/store/authStore';

import { navigateTo } from './utils.ts';
import { duellyEventEmitter } from '@/services/eventBus';
import SearchInput from '@/components/search/SearchInput.vue';
import SearchSheet from '@/components/search/SearchSheet.vue';

type SearchType = 'tag' | 'key'; // results combine both; we still accept from sheet


export default /*@__PURE__*/_defineComponent({
  __name: 'SideNavBar',
  setup(__props) {

const route = useRoute();
const router = useRouter();
const authStore = useAuthStore();

const userProfile = ref(authStore.getUserProfile());
const sheetOpen = ref(false);
const prefill = ref<{ q: string }>({ q: '' });

const isLoggedIn = computed(() => authStore.ensureAuthTokens());

function viewNavBar(): boolean {
    return !(route.path === '/login' || route.path === '/' || route.path.startsWith('/admin'));
}

// SearchSheet selects a term; we always route to combined results
function goResults({ type, term }: { type: 'tag' | 'key'; term: string }) {
    const q = term.trim().toLowerCase();
    if (!q) return;
    sheetOpen.value = false; // close the sheet so focus returns to page
    router.push({
        path: '/search/results',
        query: { q, type }, // <- forward the kind
    });
}

function navigateToChallengeFeedView() {
    window.location.href = '/post-feed-view?type=challenge&reset';
}

return (_ctx: any,_cache: any) => {
  return (viewNavBar())
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", {
          class: "nav-button",
          onClick: navigateToChallengeFeedView
        }, [
          _createElementVNode("img", {
            src: _unref(logo),
            alt: "Duelly Logo",
            class: "logo-img"
          }, null, 8, _hoisted_2)
        ]),
        _createVNode(SearchInput, {
          placeholder: "Search tags or keywords… ( / )",
          onOpenSheet: _cache[0] || (_cache[0] = 
                (p) => {
                    prefill.value.q = p.q ?? '';
                    sheetOpen.value = true;
                }
            )
        }),
        _createVNode(SearchSheet, {
          open: sheetOpen.value,
          "onUpdate:open": _cache[1] || (_cache[1] = ($event: any) => ((sheetOpen).value = $event)),
          initialQuery: prefill.value.q,
          onClose: _cache[2] || (_cache[2] = ($event: any) => (sheetOpen.value = false)),
          onSelectTerm: goResults
        }, null, 8, ["open", "initialQuery"]),
        _cache[12] || (_cache[12] = _createElementVNode("hr", { class: "mt=-2" }, null, -1)),
        _createElementVNode("div", {
          class: "nav-button",
          onClick: navigateToChallengeFeedView
        }, _cache[7] || (_cache[7] = [
          _createElementVNode("span", { style: {"font-size":"28px !important"} }, "🎯", -1),
          _createElementVNode("h2", null, "Challenges", -1)
        ])),
        _createElementVNode("div", {
          class: "nav-button",
          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$router.push({ path: '/create-content', query: { type: 'challenge' } })))
        }, _cache[8] || (_cache[8] = [
          _createElementVNode("span", { style: {"font-size":"28px !important"} }, "✨", -1),
          _createElementVNode("h2", null, "Upload", -1)
        ])),
        _createElementVNode("div", {
          class: "nav-button",
          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$router.push('/notifications')))
        }, _cache[9] || (_cache[9] = [
          _createElementVNode("span", { style: {"font-size":"28px !important"} }, "🔔", -1),
          _createElementVNode("h2", null, "Notifications", -1)
        ])),
        _cache[13] || (_cache[13] = _createElementVNode("div", { class: "nav-button" }, null, -1)),
        (isLoggedIn.value)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "nav-button",
              onClick: _cache[5] || (_cache[5] = ($event: any) => (_unref(navigateTo)(_ctx.$router, '/user-management')))
            }, [
              _createVNode(ProfilePhoto, {
                id: "step3",
                class: "mr-2",
                username: userProfile.value.username,
                profile_photo: userProfile.value.profile_photo,
                size: "small"
              }, null, 8, ["username", "profile_photo"]),
              _cache[10] || (_cache[10] = _createElementVNode("h2", null, "Profile", -1))
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createElementVNode("a", {
                onClick: _cache[6] || (_cache[6] = ($event: any) => (_unref(duellyEventEmitter).emit('show-login-overlay')))
              }, _cache[11] || (_cache[11] = [
                _createElementVNode("h2", null, "Login", -1)
              ]))
            ]))
      ]))
    : _createCommentVNode("", true)
}
}

})